module.exports = __webpack_public_path__ + "static/media/BM_ORU_220.85696c2c.png";